import { getKpiResultsAndProviders } from "../opendata";
import { CategoryChartVisibilityFn } from "../categoryChart";
import { PROVIDER_CONNECTION_TYPE } from "../misc";

export const doKpisForTheProvidersExistAndTheyNotBulk: CategoryChartVisibilityFn = async ({
    locationAdminIds,
    kpis = []
}) => {
    const { results } = await getKpiResultsAndProviders(kpis, locationAdminIds, providers => {
        return providers?.find(p => p?.connectionSizeCategory !== PROVIDER_CONNECTION_TYPE.bulk) != null;
    });
    return results.filter(d => d.value != null).length > 0;
};
